import React, {useEffect, useState} from "react";
import Select from "react-select";
import notyfApi from "../../../utils/notyfApi";
import {useFormikContext} from "formik";
import portalApi from "../../../api/portal";

// Search for NAW and update form values
const NawSelector = () => {
    const {values, setValues} = useFormikContext()


    const [nawContacts, setNawContacts] = useState([])
    const [searchTerm, setSearchTerm] = useState("")


    useEffect(() => {
        // When the search term changes, get the corresponding naw contacts.
        getOptions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm])

    const getOptions = async () => {
        if (!searchTerm) return setNawContacts([])
        const res = await portalApi.getNaw(searchTerm)
        if(!res.ok) return notyfApi.error("Probleem met contact gegevens ophalen")
        let temp = []
        for (let n of res.data.naw) {
            temp.push({
                value: n,
                label: `${n.sales_contact_firstname} ${n.sales_contact_surname_prefix || ""} ${n.sales_contact_lastname} - ${n.sales_account_name}`
            })
        }
        setNawContacts(temp)


    }

    // Set the information from the selected naw contact.
    const set = (e) => {
        setValues({
            ...values,
            service_form_project_account_name: e.sales_account_name || "",
            service_form_project_street: e.sales_account_street || "",
            service_form_project_street_nr: e.sales_account_street_nr || "",
            service_form_project_postal_code: e.sales_account_postal_code || "",
            service_form_project_city: e.sales_account_city || "",
            service_form_project_title: e.sales_contact_title || "",
            service_form_project_firstname: e.sales_contact_firstname || "",
            service_form_project_surname_prefix: e.sales_contact_surname_prefix || "",
            service_form_project_lastname: e.sales_contact_lastname || "",
            service_form_project_email: e.sales_contact_email || "",
            service_form_project_account_phone_nr: e.sales_account_phone_nr || "",

        })
    }

    return <Select options={nawContacts}
                   onKeyDown={e => setSearchTerm(e.target.value)}
                   onChange={e => set(e.value)}
                   noOptionsMessage={() => 'Geen contactpersonen gevonden'}
                   className={"mb-3"}
    />

}

export default NawSelector;